import React, { useMemo } from 'react';
import { TagFieldSC } from './tag-field.styled';
import { IEVisitTag } from '../../../../types/e-visits';
import { getTagColors } from '../../e-visits/e-visits.util';

type TagProps = {
  tag: IEVisitTag;
};

const TagField: React.FunctionComponent<TagProps> = ({ tag }) => {
  const { backgroundColor, textColor } = useMemo(() => getTagColors(tag.color), [tag]);
  return (
    <TagFieldSC backgroundColor={backgroundColor} textColor={textColor}>
      <div className={'tag'}>{tag.name}</div>
    </TagFieldSC>
  );
};

export default React.memo(TagField);
